// Provjera zatvara li se bilanca: UKUPNO AKTIVA = UKUPNO PASIVA.
//
// Obrazac GFI-POD slaze aktivu iz razreda 0, 1, 3 i 6, a pasivu iz razreda 2 i 9.
// Razredi 4, 5, 7 i 8 (troskovi, rashodi, prihodi, rezultat) nisu ni u jednoj
// strani - oni se na kraju godine zatvaraju u razred 9. Zato vrijedi:
//
//   aktiva - pasiva = neravnoteza dnevnika - saldo razreda 4,5,7,8 - knjizenja bez konta
//
// Provjereno na cijeloj bazi: identitet vrijedi na svih 312 firma/godina, a svih
// 195 zakljucenih i uravnotezenih godina zatvara se u nulu. Dakle kad se bilanca
// ne zatvori, ne trazi se greska u obrascu nego u knjizenjima - a ovaj racun
// kaze u kojima.
//
// Tri su moguca razloga i svaki se imenuje zasebno:
//
//   nezatvoren rezultat   godina jos nije zakljucena, razredi 4,5,7,8 nisu nula
//   neuravnotezen dnevnik duguje <> potrazuje
//   knjizenje bez konta   redak ne pripada nijednom razredu, pa ispada i iz
//                         aktive i iz pasive, dok dnevnik i dalje izgleda uredno
//                         - to se nigdje drugdje ne vidi

const broj = (v) => (parseFloat(v) || 0)
const r2 = (v) => Math.round((broj(v) + Number.EPSILON) * 100) / 100
const NULA = 0.005

// Saldo po razredu (prva znamenka konta) iz zbirnih redaka bruto bilance.
// Tekuca godina dolazi kao "pItems" sa zbirnim recima "Sin.ukupno:" (konto u
// "oneCond"), prethodna kao sirovi redci iz "/mainledgerdetail/card" (konto u
// "account2").
const saldoPoRazredu = (redci, tekuca) => {
  const po = {}
  const izvor = tekuca
    ? (redci || []).filter(x => x.itLine === 'Sin.ukupno:')
    : (redci || [])
  izvor.forEach(x => {
    const konto = String((tekuca ? x.oneCond : x.account2) || '').trim()
    const razred = konto.charAt(0) || ''
    const d = broj(tekuca ? x.oneTotal1 : x.totalDebit)
    const p = broj(tekuca ? x.oneTotal2 : x.totalCredit)
    po[razred] = (po[razred] || 0) + d - p
  })
  return po
}

const zbroji = (po, razredi) => razredi.reduce((z, k) => z + (po[k] || 0), 0)

// Jedna godina: sto pise u obrascu, sto kazu knjizenja i gdje je razlika.
const jednaGodina = (aktiva, pasiva, po) => {
  const razlika = r2(aktiva - pasiva)
  const rezultat = r2(zbroji(po, ['4', '5', '7', '8']))
  const bezKonta = r2(po[''] || 0)
  const neravnoteza = r2(Object.keys(po).reduce((z, k) => z + po[k], 0))

  const razlozi = []
  if (Math.abs(rezultat) > NULA) {
    razlozi.push({ sto: 'godina nije zaključena', iznos: r2(-rezultat), kolika: r2(rezultat) })
  }
  if (Math.abs(neravnoteza) > NULA) {
    razlozi.push({ sto: 'dnevnik nije uravnotežen (duguje ≠ potražuje)', iznos: neravnoteza, kolika: neravnoteza })
  }
  if (Math.abs(bezKonta) > NULA) {
    razlozi.push({ sto: 'knjiženja bez konta - ispadaju iz obje strane', iznos: r2(-bezKonta), kolika: bezKonta })
  }
  const objasnjeno = r2(-rezultat + neravnoteza - bezKonta)

  return {
    aktiva: r2(aktiva),
    pasiva: r2(pasiva),
    razlika,
    zatvara: Math.abs(razlika) <= NULA,
    rezultat,
    neravnoteza,
    bezKonta,
    razlozi,
    // Ako ovo nije nula, razliku ne objasnjava nijedan poznati razlog i vrijedi
    // je pogledati rucno - znacilo bi da obrazac negdje ne pokriva neki konto.
    neobjasnjeno: r2(razlika - objasnjeno)
  }
}

const nadi = (redci, naslov) =>
  (redci || []).find(x => String(x.col3 || '').trim() === naslov) || {}

/**
 * @param {Object} ulaz
 *   redci       retci obrasca (fullGFI) - iz njih se citaju UKUPNO AKTIVA i PASIVA
 *   pItems      bruto bilanca tekuce godine
 *   pOldItems   bruto bilanca prethodne godine
 * @returns {{jeBilanca: boolean, tekuca: Object, prethodna: Object}}
 */
export const provjeriBilancu = (ulaz) => {
  const redci = (ulaz && ulaz.redci) || []
  const A = nadi(redci, 'UKUPNO AKTIVA')
  const P = nadi(redci, 'UKUPNO PASIVA')
  // Bez ta dva retka nije rijec o bilanci (npr. RDG), pa se nema sto provjeriti.
  const jeBilanca = A.col3 !== undefined && P.col3 !== undefined
  if (!jeBilanca) { return { jeBilanca: false, tekuca: null, prethodna: null } }

  return {
    jeBilanca: true,
    tekuca: jednaGodina(broj(A.col6), broj(P.col6), saldoPoRazredu(ulaz.pItems, true)),
    prethodna: jednaGodina(broj(A.col5), broj(P.col5), saldoPoRazredu(ulaz.pOldItems, false))
  }
}

export default provjeriBilancu
